import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const WellnessTrainSchema = withDefaults({
  type: 'wellness-train',
  objectExtensions: ['wellness-train'],
  fields: [
    {
      kind: 'attribute',
      name: 'wellnessTrain',
    },
    {
      kind: 'attribute',
      name: 'wellnessTrainRating',
    },
    {
      kind: 'attribute',
      name: 'wellnessTrainDescription',
    },
    {
      kind: 'attribute',
      name: 'balanceUpdatedAt',
    },
    {
      kind: 'attribute',
      name: 'obsUpdatedAt',
    },
    {
      kind: 'attribute',
      name: 'calculationUpdatedAt',
    },
    {
      kind: 'attribute',
      name: 'actions',
    },
    {
      kind: 'attribute',
      name: 'nslds',
    },
    {
      kind: 'attribute',
      name: 'nsldsAsOf',
    },
    {
      kind: 'attribute',
      name: 'nsldsProcessedAsOf',
    },
    {
      kind: 'attribute',
      name: 'hasFfelLoans',
    },
    {
      kind: 'attribute',
      name: 'hasDirectLoans',
    },
    {
      kind: 'attribute',
      name: 'hasPerkinsLoans',
    },
    {
      kind: 'attribute',
      name: 'hasParentplusLoans',
    },
    {
      kind: 'attribute',
      name: 'inGracePeriodOrDeferment',
    },
    {
      kind: 'attribute',
      name: 'nonOptimalRepaymentPlan',
    },
    {
      kind: 'attribute',
      name: 'idrRepaymentPlan',
    },
    {
      kind: 'attribute',
      name: 'pslfCountShown',
    },
    {
      kind: 'attribute',
      name: 'idrAnniversaryDate',
    },
    {
      kind: 'attribute',
      name: 'balanceGoingDown',
    },
    {
      kind: 'attribute',
      name: 'hasRecentForbearance',
    },
    {
      kind: 'attribute',
      name: 'hasDefaultHistory',
    },
    {
      kind: 'attribute',
      name: 'currentlyInDefault',
    },
    {
      kind: 'attribute',
      name: 'pslfFormSubmittedDate',
    },
    {
      kind: 'attribute',
      name: 'pslfFormSubmitted',
    },
    {
      kind: 'attribute',
      name: 'pslfSubmittedWithin11m',
    },
    {
      kind: 'attribute',
      name: 'pslfSubmittedWithin4m',
    },
    {
      kind: 'attribute',
      name: 'fileType',
    },
    {
      kind: 'attribute',
      name: 'calc',
    },
    {
      kind: 'attribute',
      name: 'version',
    },
    {
      kind: 'attribute',
      name: 'statementBalanceUpdatedAt',
    },
    {
      kind: 'attribute',
      name: 'statementObsUpdatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: 'wellnessTrain',
      },
    },
    {
      kind: 'hasMany',
      name: 'componentDefinitions',
      type: 'wellness-insights-component-definition',
      options: {
        async: false,
        inverse: 'wellnessTrain',
      },
    },
  ],
});

export default WellnessTrainSchema;
